/**
 * Main styling file for Loading Page.
 */

import styled, { keyframes } from "styled-components";

const typingAnimation = keyframes`
   from { width: 0 }
   to { width: 100% }
`;


const LoadingPageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  top: 0;
  margin: 0;
`;

const LogLineContainer = styled.div`
  width: 100%;
  height: 100%;
`;

const LogLineComponent = styled.p`
  font-size: 17px;
  color: #c0c0c0;
  padding-top: 13px;
  overflow: hidden;
  white-space: nowrap;
  letter-spacing: 0.20em;
  animation: ${typingAnimation} 3.5s steps(40, end);
`;

export { LogLineComponent, LoadingPageContainer, LogLineContainer };
